export default {
    props: {
        ads: {
            type: Array,
            required: true
        },
        searchQuery: {
            type: String,
            default: ''
        }
    },

    methods: {
        //키워드 하이라이트 볼드 처리
        highlightKeyword(text) {
            if (!this.searchQuery || !text) return text;
            const keywords = this.searchQuery.split(' ').filter(k => k.length >= 1);
            return keywords.reduce((res, keyword) => {
                const escaped = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
                const regex = new RegExp(`(${escaped})`, 'gi');
                return res.replace(regex, '<em class="emph_g">$1</em>');
            }, text);
        },

        // 공통 프로필 정보 (class, imageUrl)
        getProfileInfo(ad) {
            const imageUrl = ad.profileImageUrl || ad.faviconImageUrl || null;
            const finalUrl = imageUrl || '//t1.daumcdn.net/cafe_image/app/ad/ico_fav.png';

            return {
                profileImgUrl: finalUrl,
                profileClass: imageUrl ? 'is-profile' : ''
            };
        },

        // 공통 URL 정리 로직
        getCleanDisplayUrl(displayUrl) {
            if (!displayUrl) return '';
            return displayUrl
                .replace(/^https?:\/\/(www\.)?/i, '')
                .replace(/\/$/, '');
        },

        // 이미지 로드 실패 핸들러
        handleImageError(event, el) {
            event.target.closest(el).style.display = 'none';
        }
    }
}